/**
 * E V E N T S
 */

const Events = {


	Checkout : {
		SUCCESS : "checkoutSuccess",
        RETRIEVED_KEY : "checkoutRetrievedKey"
	},
	Form : {
		SUCCESS : "formSuccess",
		ERROR : "formError"
	},

};

export default Events;